<template>
  <v-app @hide-drawer="showDrawer = false" :style="cssProps">    
    <v-navigation-drawer :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}" touchless mobile-break-point=0 disable-route-watcher disable-resize-watcher v-if="routemeta.drawerCmp" persistent :mini-variant="miniVariant" :clipped="true" v-model="showDrawer"  fixed app>
      <component v-if="routemeta.drawerCmp " :is="routemeta.drawerCmp" />
    </v-navigation-drawer>    
    <v-navigation-drawer :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}" touchless mobile-break-point=0 disable-route-watcher disable-resize-watcher  :width="drawerRightWidth" v-if="routemeta.rightDrawerCmp" persistent :right="true" :clipped="true" v-model="showRightDrawer" fixed app :temporary="this.$vuetify.breakpoint.name == 'xs'">
      <component v-if="routemeta.rightDrawerCmp " :is="routemeta.rightDrawerCmp" />
    </v-navigation-drawer>   
    <v-toolbar :style="darkmode?darkModeHomeStyles:{}" dark color="#4066aa" app :clipped-left="true" :clipped-right="true">      
      <v-btn :input-value="showDrawer" v-if="showDrawerIcon" icon @click.stop="toggleDrawer" :title="$t(showDrawer?'App.HideLeftDrawerTooltip':'App.ShowLeftDrawerTooltip')">
        <v-icon>{{drawerIcon}}</v-icon>
      </v-btn>
      <!--v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn-->            
      <img class="hidden-xs-only logo" src="./assets/logo-glimpse-alseamar.png" />
      <v-spacer class="hidden-xs-only"></v-spacer>      
      <!--<img class="hidden-md-and-down logo pr-5" src="./assets/logo-centralweb.png" @click="$store.myActions.UI_ADD_SNACK_MESSAGE('centralweb')" />-->
      <img class="hidden-md-and-down logo" src="./assets/logo-alseamar.svg"  />
      <!--<img class="hidden-md-and-down logo pl-5" src="./assets/onera-logo.png" @click="$store.myActions.UI_ADD_SNACK_MESSAGE('onera')" />-->
      <v-spacer></v-spacer>             
      <v-icon class="mr-2" v-if="isAuthenticated" :style="{color,cursor:'help'}" :title="`${$t('App.WebSocketTooltip')} ${networkTooltip}`" v-html="iconnetwork"></v-icon>
      <v-btn icon exact v-if="accesDebugLog.visible" :disabled="!accesDebugLog.enable" :to="accesDebugLog.enable?{name:'Debug'}:null" :title="$t('App.Debug')">
        <v-icon>mdi-bug</v-icon>
      </v-btn>  
      <v-btn icon  @click.stop="$store.myActions.UI_TOGGLE_DARKMODE()">
        <v-icon v-text="darkmode?'mdi-weather-night':'mdi-weather-sunny'"></v-icon>
      </v-btn>  
      <v-btn icon exact :to="{name:'Home'}" :title="$t('App.BackHome')">
        <v-icon>mdi-home</v-icon>
      </v-btn>      
      <v-menu  v-if="isAuthenticated" offset-y>                 
        <v-btn slot="activator" icon exact :title="$t(`App.Bell${soundNotification}`)">
          <v-icon v-text="soundNotification=='Alert'?'mdi-bell-alert':soundNotification=='Disable'?'mdi-bell-cancel':soundNotification=='DisableSim'?'mdi-bell-remove':'mdi-bell'"></v-icon>
        </v-btn> 
        <v-list>          
          <v-list-tile @click="$store.myActions.UI_SET_SOUND_NOTIFICATION('Enable')">
            <v-list-tile-action>                            
              <v-icon>mdi-bell</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.BellEnable')}}</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile @click="$store.myActions.UI_SET_SOUND_NOTIFICATION('Alert')">
            <v-list-tile-action>                            
              <v-icon>mdi-bell-alert</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.BellAlert')}}</v-list-tile-title>            
          </v-list-tile>          
          <v-list-tile @click="$store.myActions.UI_SET_SOUND_NOTIFICATION('Disable')">
            <v-list-tile-action>                            
              <v-icon>mdi-bell-cancel</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.BellDisable')}}</v-list-tile-title>            
          </v-list-tile> 
          <!-- <v-list-tile @click="$store.myActions.UI_SET_SOUND_NOTIFICATION('DisableSim')">
            <v-list-tile-action>                            
              <v-icon>mdi-bell-remove</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.BellDisableSim')}}</v-list-tile-title>            
          </v-list-tile>                    -->
        </v-list>
      </v-menu>     
      <clock class="px-4" />             
      <lang-switcher class="pl-2" />                  
      <v-menu class="pl-2" v-if="isAuthenticated" offset-y>        
        <v-toolbar-title slot="activator">
          <span style="font-size:14px">{{userName}}</span>
          <v-icon dark>mdi-menu-down</v-icon>
        </v-toolbar-title>        
        <v-list>          
          <v-list-tile @click="changePassword">
            <v-list-tile-action>                            
              <v-icon>mdi-lock-reset</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.ChangePassword')}}</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-action>                            
              <v-icon>mdi-exit-to-app</v-icon>              
            </v-list-tile-action>
            <v-list-tile-title >{{$t('App.Logout')}}</v-list-tile-title>            
          </v-list-tile>
          <coord-selector />
        </v-list>
      </v-menu>      
      <mission-operator-filter v-if="isAuthenticated" class="pl-2"  />
      <v-btn :input-value="showRightDrawer" v-if="showRightDrawerIcon" icon @click.stop="toggleRightDrawer"  :title="$t(showRightDrawer?'App.HideRightDrawerTooltip':'App.ShowRightDrawerTooltip')">
        <v-icon>{{rightDrawerIcon}}</v-icon>
      </v-btn>
    </v-toolbar>     
    <v-content :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}">                          
      <div v-if="showHomeImage" class="back-blur" :style="`background-image:url(${homeImagesConfig.images[curentImageIdx]})!important`">
        <div class="blur">        
        </div>              
      </div>        
      <div class="btnApercu" v-if="showHomeImage && !showImageLightbox">
        <v-btn icon exact  @click="showImageLightbox = true" :title="$t('App.ShowImage')">
          <v-icon color="white">mdi-magnify</v-icon>
        </v-btn>               
      </div>       
      <div v-if="showHomeImage && showImageLightbox" class="imgViewer" :style="`background-image:url(${homeImagesConfig.images[curentImageIdx]})!important`">
          <div class="btnClose" @click="showImageLightbox = false">
            <v-btn icon exact  @click="showImageLightbox = true" :title="$t('App.CloseImage')">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>  
          </div>
      </div>  
      <div class="maincontent" :class="{'back-home':showHomeImage}" :style="showHomeImage?`background-image:url(${homeImagesConfig.images[curentImageIdx]})!important`:''">        
        <router-view />
      </div>
    </v-content>         
    <app-movable-dialog-container :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}"/>
    <app-infos-dialog-container :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}" />
    <v-snackbar auto-height v-model="showSnacks" bottom right :timeout="4000" :style="darkmode?showHomeImage?darkModeHomeStyles:darkModeStyles:{}">
      <ul>
        <li v-for="(message,index) in snackMessages" :key="index">{{message}}</li>
      </ul>      
      <v-btn color="primary" flat @click="$store.myActions.UI_CLOSE_SNACKBAR" >{{$t('App.Close')}}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import CoordSelector from '@/components/shared/CoordSelector'
import LangSwitcher  from '@/components/shared/LangSwitcher'
import AppMovableDialogContainer from '@/components/shared/AppMovableDialogContainer'
import AppInfosDialogContainer from '@/components/shared/AppInfosDialogContainer'
import types from '@/store/all-mutation-types'
import Clock from '@/components/shared/Clock.vue'
import { SecurityItemsKeys } from './enum/SecurityItems';
import { SoundNotification } from './enum/SoundNotification'
import { DataPoolGlobalKeys } from './enum/DataPool'
import { HomeImagesConfig } from './models/datapool/HomeImagesConfig'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { getSimulationStatusTradKey } from './enum/SimulationStatus'
import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter'

export default {
  name: 'App',  
  components: {CoordSelector,LangSwitcher,AppMovableDialogContainer,AppInfosDialogContainer,Clock,MissionOperatorFilter},
  data () {
    return {            
      showDrawerIcon: true,      
      showImageLightbox:false,
      showRightDrawerIcon: true,
      fixed: false,  
      miniVariant: false,      
      title: 'Aglimms',
      showSnack : false,
      homeImagesConfig : new HomeImagesConfig() 
    }
  },  
  computed:{
    isConnected(){
      return this.$store.myGetters.isConnected
    },
    wasOffline(){
      return this.$store.myGetters.wasOffline
    },    
    showDialogSimulationFinished(){
      return this.$store.myGetters.showDialogSimulationFinished
    },
    color(){
      return this.isConnected?(this.wasOffline?'#f5d02a':'#00FF00'):'#FF0000'
    },
    iconnetwork(){
      return this.isConnected?'mdi-network':'mdi-network-off' 
    },
    networkTooltip(){
      return this.isConnected?(this.wasOffline?this.$t('App.WebSocketWKO'):this.$t('App.WebSocketOK')):this.$t('App.WebSocketKO')
    },
    snackMessages(){
      return this.$store.myGetters.snackMessages
    },
    soundNotification(){
      return this.$store.myGetters.soundNotification
    },
    isAuthenticated(){
      return this.$store.myGetters.isAuthenticated
    },
    darkmode(){
      return this.$store.myGetters.darkmode
    },
    isWsReady(){
      return this.$store.myGetters.isWsReady
    },
    showSnacks:{
      get(){
        return this.showSnack
      },
      set(newValue) {
        this.$store.myActions.UI_CLOSE_SNACKBAR()
      }
    },
    userName(){
      return this.$store.myGetters.userProfile.prenom + " " + this.$store.myGetters.userProfile.nom
    },
    showDrawer:{
      get(){
        return this.$store.myGetters.isDrawerOpen
      },
      set(newValue) {
        this.$store.myActions.UI_SET_DRAWER_VISIBILITY(newValue)
      }
    },
    showRightDrawer:{
      get(){
        return this.$store.myGetters.isRightDrawerOpen
      },
      set(newValue) {        
        this.$store.myActions.UI_SET_RIGHT_DRAWER_VISIBILITY(newValue)
      }
    },
    clipped(){
      return this.$vuetify.breakpoint.name == 'xs' ||
            this.$vuetify.breakpoint.name == 'sm'
    },
    routemeta(){
      return this.$route.matched.reduce((a,item) => { return {...a,...item.meta}},{})
    },
    drawerIcon(){
      return this.routemeta.drawerIcon || 'mdi-menu'
    },
    rightDrawerIcon(){
      return this.routemeta.rightDrawerIcon || 'mdi-menu'
    },
    drawerRightWidth() {
      return this.clipped?350:500
    },
    darkModeHomeStyles(){
      return {
        'filter':'grayscale(20%) brightness(0.8)'
      }
    },
    darkModeStyles(){
      return {
        'filter':'invert(95%) hue-rotate(180deg) grayscale(10%) brightness(0.8)'
      }
    },
    cssProps () {
      return {
          '--secondary-color': this.$vuetify.theme.secondary,
          '--primary-color': this.$vuetify.theme.primary
      }
    },
    userSecurity(){
      return this.$store.myGetters.userSecurity
    },
    accesDebugLog() {
     return this.userSecurity[SecurityItemsKeys.DEBUG_LOG]
    },
    originalHomeImageConfigStr() {    
      return (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.homeImages']) || "")
    },
    curentImageIdx() {
      const now = new Date().getTime()
      const start = new Date(new Date().getFullYear(), 0, 0).getTime()
      const diff = now - start
      const oneDay = 1000 * 60 * 60 * 24
      const day = Math.floor(diff / oneDay)
      return day % this.homeImagesConfig?.images?.length
    },
    showHomeImage(){
      return this.$route.name=='Home' || this.$route.name=='Login' || this.$route.name=='CreatePassword' || this.$route.name=='ChangePassword'
    }
  },  
  created() {                
    this.updateDrawer()    
  },
  mounted() {
    window.addEventListener('keydown', (e) => {
        this.$store.myActions.UI_SET_KEYPRESS({code:e.code,pressed:true})
    })
    window.addEventListener('keyup', (e) => {
        this.$store.myActions.UI_SET_KEYPRESS({code:e.code,pressed:false})
    })    
    if(this.isWsReady) this.$connect(this.$store.myGetters.wsUrl)   
    this.homeImagesConfig = HomeImagesConfig.createHomeImagesConfig(this.originalHomeImageConfigStr)        
  },
  watch:{
    '$route' (to, from) {
      this.updateDrawer()
    },
    showDialogSimulationFinished(newValue){           
      if(newValue != '') {        
        this.$confirm(newValue,{title: '',buttonTrueText:"Ok",buttonFalseText:""})
        this.$store.myActions.MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED()
      }
    },
    isAuthenticated(newValue) {      
      if(!newValue) {
        //memorise le chemin courant avant la redirection sur la page de login
        this.$store.myActions.UI_SET_REDIRECT_PATH(this.$route.path)
        this.$router.push({name:'Login'})        
      }
    }, 
    originalHomeImageConfigStr(newValue){
      this.homeImagesConfig = HomeImagesConfig.createHomeImagesConfig(this.originalHomeImageConfigStr)        
    },  
    isConnected(newValue){
        if(newValue) this.$store.myActions.SOCKET_SENDMESSAGE(`${this.$store.myGetters.token.replace("Bearer ","rtk:")}.${document.cookie.match('(^|;)\\s*jwth\\s*=\\s*([^;]+)')?.pop() || ''}`)        
    },
    isWsReady(newValue){
      if(newValue) {
        this.$connect(this.$store.myGetters.wsUrl)             
      }
      else this.$disconnect()
    },
    snackMessages(newValue)  {      
      this.showSnack = false
      this.$nextTick(() => {
        this.showSnack = newValue.length > 0
      })      
    }
  },
  methods:{ 
    updateDrawer() {          
      //masque le drawer si demandé
      if(this.routemeta.hideDrawer != 'auto') {
        this.showDrawer = !!this.routemeta.drawerCmp &&  !this.routemeta.hideDrawer && !this.clipped
      }
      //masque l'icon du drawer
      this.showDrawerIcon = !!this.routemeta.drawerCmp  && !this.routemeta.hideDrawerIcon
      //masque le drawer droit si demandé
      if(this.routemeta.hideRightDrawer != 'auto') {        
        this.showRightDrawer = !!this.routemeta.rightDrawerCmp &&  !this.routemeta.hideRightDrawer && !this.clipped        
      }
      //masque l'icon du drawer droit
      this.showRightDrawerIcon = !!this.routemeta.rightDrawerCmp  && !this.routemeta.hideRightDrawerIcon
    },
    toggleDrawer(){
      if(this.clipped) this.showRightDrawer = false
      this.showDrawer = !this.showDrawer
    },
    toggleRightDrawer() {
      if(this.clipped) this.showDrawer = false
      this.showRightDrawer = !this.showRightDrawer
    },
    logout() {   
      //force redirection sur la home avant deconnexion pour arriver sur la home apres login
      if(this.$route.name != 'Home') this.$router.push({name:'Home'})      
      this.$store.myActions.AUTH_LOGOUT()
    },
    changePassword(){
      this.$router.push({name:'ChangePassword'})      
    }
  }
} 
</script>

<style scope>  

.border-box{
  box-sizing: border-box;
}
html{
  overflow: hidden;
}
.logo{
    max-height:48px;
    max-width:45%;
}
.btnApercu, .btnClose{
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 3;
}
.imgViewer{  
  background-color: #FFF;
  background: url('./assets/home-slide-bridges02-nb.jpg') center center;  
  background-size: contain;
  position: absolute;
  background-repeat: no-repeat;  
  z-index: 3;
  top:0px;
  left:0px;
  width: 100%;
  height: 100%;
}
.back-home{
  background: url('./assets/home-slide-bridges02-nb.jpg') center center;
  background-size: contain;
  background-repeat: no-repeat;  
  z-index: 1;  
}
.back-blur{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;  
  background: url('./assets/home-slide-bridges02-nb.jpg') center center;
  background-size: cover;
  background-repeat: no-repeat;  
}
.blur{
  background: rgba(255, 255, 255, 0.2); 
  backdrop-filter: blur(8px); 
  height: 100%;
	width: 100%;
}
 .maincontent{
    position: absolute;
    top:0px;left: 0px;right: 0px;bottom: 0px;
    overflow: hidden;
  }
</style>

<style>
.v-label,.v-list__tile{
  font-size:14px;
}

.v-window__container, .v-window-item{
    display:flex;
    flex:1 1 auto;
    overflow: hidden;
}  

aside{
  display:flex;
}

.text__highlight{
    background:  var(--primary-color)!important;    
    color: #bbb;
}

.flex-column {
  flex-direction: column;
}
.flex-grow-0 {
  flex-grow: 0!important;
}
.flex-grow-1 {
  flex-grow: 1!important;
}
.jsutify-space-between{
  justify-content: space-between;
}
  

</style>